var Midttrafik2016 = Midttrafik2016 || {};
Midttrafik2016.forms = Midttrafik2016.forms || {};

Midttrafik2016.forms.airport = new function () {
    var self = this;
    this.init = function() {
        this.setupForm();
    };

    this.setupForm = function() {
        var airportForm = $('#airportRouteForm');
        if (airportForm.length > 0) {
            airportForm.on("submit", function (e)
            {
                $('.airportbus-schedule-result').fadeIn();
                e.preventDefault();
                var formData = airportForm.serialize();
                $.ajax({
                    type: 'POST',
                    url: '/umbraco/Surface/BusScheduleAirport/SearchAirportBus',
                    data: formData,
                    dataType: 'html',
                    success: function (data) {
                        $('#resultContainer').html(data);
                    }
                });
            });

            var routeSelector = $('#ddlType', airportForm);
            var dateSelector = $('#tbDate', airportForm);
            if (routeSelector.length > 0 && dateSelector.length > 0) {

                //Collect route data
                var routes = $('option', routeSelector);
                var routesTranslated = [];
                for (var iRoute = 0; iRoute < routes.length; iRoute++) {
                    var route = $(routes[iRoute]);
                    routesTranslated.push({
                        option: route,
                        airId: route.data('air-id'),
                        validFrom: moment(route.data('valid-from')),
                        validTo: moment(route.data('valid-to'))
                    });
                }

                //Updates the route drop down list dependant on date selected
                var updateRouteDisplay = function() {
                    var selectedAirId = -1;
                    var selectedRoute = routeSelector.val();
                    if (selectedRoute) {
                        var selectedRouteArray = selectedRoute.split('||');

                        if (selectedRouteArray && selectedRouteArray[0]) {
                            selectedAirId = selectedRouteArray[0];
                        }
                    }

                    var selectedDate = dateSelector.val();
                    var date = (selectedDate.length == 0) ? moment() : moment(selectedDate, 'MMMM D, YYYY');
                    for (var iRouteTranslated = 0; iRouteTranslated < routesTranslated.length; iRouteTranslated++) {
                        var route = routesTranslated[iRouteTranslated];

                        //console.info(route.option.selected,route.option.prop('selected'),date >= route.validFrom,date <= route.validTo);

                        if (date >= route.validFrom && date <= route.validTo) {
                            route.option.show();
                            if (route.option.data('air-id') == selectedAirId) {
                                routeSelector.val(route.option.val());
                            }
                        } else {
                            route.option.hide();
                        }
                    }
                };

                //Init display
                updateRouteDisplay();

                //Events to trigger updates
                dateSelector.change(function () {
                    updateRouteDisplay();
                });
            }
        }
    }
} ();
